import React, { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Alert } from 'rsuite';
import { setSingleReducer } from '../../../../../../../actions/actionsAnaliseCompetitividade';
import { LoadingMenu } from '../../../../../../../components/LoadingSpinner';
import SelectPill from '../../../../../../../components/SelectPill';

import arrowRightIcon from '../../../../../../../assets/icons/icon_arrow-right-gray.svg';
import { useChangePlaceholder } from '../../../hooks/useChangePlaceholder';
import { filtrosDataType } from '../../../utils';
import styles from './styles.module.scss';

export const RetailRedeSelect = ({
  placeholder,
  addSelect,
  onSelectReference,
  onSelectCompetitors,
  onCleanReference,
  onCleanCompetitors,
  savedRedeSelectedObject,
  redeState,
  redeHandlers,
}) => {
  const { filterIsEmpty } = useSelector(
    state => ({
      filterIsEmpty: state.analiseCompetitividadeDataReducer.filterIsEmpty,
    }),
    shallowEqual,
  );

  const dispatch = useDispatch();

  const { selectPlaceholder, handlePlaceholderChange, handleThirdPlaceholderChange, handleCleanCheckPlaceholder } = useChangePlaceholder(
    placeholder,
    addSelect,
  );

  const handleReferenceOnSelect = (value, item) => {
    handlePlaceholderChange('second');
    onSelectReference(value, item);
    redeHandlers.handleSelectReferenceDoubleItem(filtrosDataType[selectPlaceholder?.label], item);
  };

  const handleCompetitorsOnSelect = (value, item) => {
    const hasValue = redeState.doubleListData.competidoras.value.includes(item.value);
    const valueArray = value.length > 10 ? value.slice(0, -1) : value;
    handleThirdPlaceholderChange(value, item);
    onSelectCompetitors(valueArray, item, hasValue);

    if (value.length > 10) {
      Alert.warning('Já existem 10 competidores selecionados.', 5000);
    } else if (hasValue) {
      redeHandlers.handleRemoveDoubleItem(filtrosDataType[selectPlaceholder?.label], item);
    } else {
      redeHandlers.handleSelectDoubleItem(filtrosDataType[selectPlaceholder?.label], item, 'competidoras');
    }
  };

  const handleReferenceOnOpen = name => {
    redeHandlers.handleGetDoubleList(name, 'referencia');
    dispatch(
      setSingleReducer('filterIsEmpty', {
        ...filterIsEmpty,
        redeReferencia: false,
      }),
    );
  };

  const handleCompetitorsOnOpen = () => {
    redeHandlers.handleGetDoubleList(selectPlaceholder?.label, 'competidoras');
    dispatch(
      setSingleReducer('filterIsEmpty', {
        ...filterIsEmpty,
        redesCompetidoras: false,
      }),
    );
  };

  const handleCompetitorsOnClean = () => {
    redeHandlers.handleCleanDoubleItem('competidoras');
    handleCleanCheckPlaceholder('third');
    onCleanCompetitors();
  };

  const handleReferenceOnClean = () => {
    redeHandlers.handleCleanDoubleItem('referencia');
    onCleanReference();
  };

  useEffect(() => {
    if (savedRedeSelectedObject) {
      redeHandlers.handleSetSavedDoubleFilters(savedRedeSelectedObject);
    }
  }, [savedRedeSelectedObject]);

  return (
    <div className={styles['select-pill-wrapper']}>
      <div className={styles['div-pill']}>Rede</div>
      <img src={arrowRightIcon} alt="" className={styles['arrow-right-icon']} />
      <SelectPill
        type="select"
        id={filterIsEmpty?.redeReferencia ? 'select-pill-is-empty' : 'select-picker-pill'}
        filter={false}
        placeholder={selectPlaceholder?.placeholder}
        name="second"
        value={redeState.doubleListData?.referencia?.value[0]}
        data={redeState.doubleListData?.referencia?.lista}
        onSearch={search => redeHandlers.handleSearchDoubleList(search, selectPlaceholder?.label, 'referencia')}
        onSelect={handleReferenceOnSelect}
        onOpen={() => handleReferenceOnOpen(selectPlaceholder?.label)}
        onClean={handleReferenceOnClean}
        locale={{
          noResultsText: 'Nenhum item encontrado',
          searchPlaceholder: 'Buscar item',
        }}
        renderMenu={menu => (
          <span>
            <LoadingMenu area="panel-filter" />
            {menu}
          </span>
        )}
      />
      <div className={styles.versus}>Vs</div>
      <SelectPill
        type="check"
        id={filterIsEmpty?.redesCompetidoras ? 'select-pill-is-empty' : 'check-picker-pill'}
        placeholder={redeState.doubleListData?.competidoras?.value?.length ? 'Redes selecionadas' : 'Escolha até 10 redes'}
        name="third"
        value={redeState.doubleListData?.competidoras?.value}
        data={redeState.doubleListData?.competidoras?.lista}
        onClean={handleCompetitorsOnClean}
        onSearch={search => redeHandlers.handleSearchDoubleList(search, selectPlaceholder?.label, 'competidoras')}
        onSelect={handleCompetitorsOnSelect}
        onOpen={handleCompetitorsOnOpen}
        locale={{
          noResultsText: 'Nenhum item encontrado',
          searchPlaceholder: 'Buscar item',
        }}
        renderMenu={menu => (
          <span>
            <LoadingMenu area="panel-filter" />
            {menu}
          </span>
        )}
      />
    </div>
  );
};
